import React from 'react';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { EnhancedErrorLayout } from './components/EnhancedErrorLayout';
import type { BFFHttpError } from '../../bff-api/model/BFFHttpError';

export const EnhancedError: FC<{ error: BFFHttpError | Error }> = ({ error }) => {
    const location = useLocation();
    const { pathname } = location;
    return <EnhancedErrorLayout error={error} path={pathname} />;
};
